import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'

export const IntegrationApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.INTEGRATION}
      scope='integration'
      envKey={apps[AppId.INTEGRATION].runtimeEnvKey}
      entryPath='./IntegrationApp'
      url={process.env.REACT_APP_INTEGRATION_APP_DEV_PATH}
      appName={apps[AppId.INTEGRATION].name}
      appProps={{
        user,
        initialPath: apps[AppId.INTEGRATION].path,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}
